import { render, staticRenderFns } from "./TableauResultatsChallengeEquipe.vue?vue&type=template&id=4a0c95aa"
import script from "./TableauResultatsChallengeEquipe.vue?vue&type=script&lang=js"
export * from "./TableauResultatsChallengeEquipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports